module.exports = __webpack_public_path__ + "static/ollie_glass-dbb3b7a555ef719cf48f6bc7a6201d3e.jpg";